import styled from '@emotion/styled'
import { SvgIcon, SvgIconProps } from '@mui/material'

const StyledG = styled.g`
  fill: ${(p) => p.theme.colors.marine};
`
const PhoneIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <StyledG>
      <path fill="none" d="M0 0H16V16H0z" />
      <path d="M9.286 11.429L11 9.857a.525.525 0 0 1 .429-.143l.286.143 4 1.857c.286.143.286.286.286.571a3.622 3.622 0 0 1-1.143 2.571 4.092 4.092 0 0 1-3 1.143 8.7 8.7 0 0 1-4-1 18.727 18.727 0 0 1-4-2.857A24.333 24.333 0 0 1 1.714 9 19.747 19.747 0 0 1 .286 5.857 8.791 8.791 0 0 1 0 3.143 3.754 3.754 0 0 1 1 1a4.344 4.344 0 0 1 2.714-1 .742.742 0 0 1 .571.286l2.143 4a.5.5 0 0 0 .143.286.525.525 0 0 1-.142.428L4.571 6.714a.638.638 0 0 0 0 .714 13.642 13.642 0 0 0 1.715 2.286 14.424 14.424 0 0 0 2.286 1.857c.285.143.571.143.714-.142z" />
    </StyledG>
  </SvgIcon>
)

export default PhoneIcon
